export interface CSVUploadMapping {
  header: string; // CSV Header Name
  field: string; // Object Field Name
}

export interface CSVUploadMappings {
  standard: CSVUploadMapping[];
  custom: CSVUploadMapping[];
}

export enum CSVUploadKind {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  DIAL_LIST = 'DIAL_LIST',
}

export type CSVUploadType = 'accountCsv' | 'contactCsv' | 'dialListCsv';

export enum CSVUploadStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
}

export interface CSVUpload {
  id: number;
  kind: CSVUploadKind;
  status: CSVUploadStatus;
  mappings: CSVUploadMappings;
  successes: number;
  failures: number;
  progress: number; // 0.0 -> 1.0
  csvFileUrl: string;
  listId: number | null;
}

export interface CreateCSVUpload {
  kind: CSVUploadKind;
  mappings: CSVUploadMappings;
  csvFileUrl: string;
  name: string;
}

export interface CSVField {
  label: string;
  name: string;
  type: string;
}

export interface CSVSchema {
  headers: string;
  pkFields: CSVField[];
  standardFields: CSVField[];
  customFields: CSVField[];
}

export interface CSVTypeContent {
  icon: string;
  name: string;
  type: string | CSVUploadType;
  description: string;
  color: string;
  background: string;
}
